export default __webpack_public_path__ + "251cbaf4a32a2cbd9cf8288c7d4cb324.png";